import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import find from 'lodash/find';
import Box from '@material-ui/core/Box';

import { handleFormItemUpdate } from 'menus/actions/menuItem';
import { closeEditCartForm } from 'cart/actions/editCart';
import { getFieldType, RADIO_BUTTON } from 'menus/utils/cartModifications';

import { UPDATE_ITEM } from 'menus/constants/ctaName';

import MenuItemDetailForm from 'menus/containers/MenuItemDetailForm';
import MenuItemImage from 'menus/components/MenuItemImage';
import MenuItemDescription from 'menus/components/MenuItemDescription';
import LaunchNotificationOnMount from 'base/containers/LaunchNotificationOnMount';
import ModalCloseButton from 'base/ui_components/ModalCloseButton';
import { getMenuItemImage } from 'menus/reducers/menuItemsDetail';
import { getItemByIdSelector } from 'base/reducers/bentoApi';
import withLoading from 'base/hoc/withLoading';
import { MENU_ITEMS_DETAIL } from 'menus/constants/entities';
import { productPreviewHelperSelectorCartItem } from 'menus/reducers/productPreview';
import { CART_ITEM } from 'menus/constants/formTypes';
import { getCartItemByIdSelector } from 'cart/selectors';

class EditCartItem extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object,
    cart: PropTypes.shape({
      online_ordering_location: PropTypes.string,
      items: PropTypes.array
    }),
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
        menuItemSlug: PropTypes.string
      })
    }),
    menuItem: PropTypes.object,
    menuItemImage: PropTypes.string,
    cartItemPreviewHelper: PropTypes.object,
    orderMaximum: PropTypes.string
  };

  static defaultProps = {
    variants: []
  };

  getPreSelectedFields = () => {
    const cartItemObject = this.getCartItemObject();

    if (!cartItemObject) {
      return {};
    }

    const {
      required_fields,
      quantity,
      order_made_for,
      special_instructions
    } = cartItemObject;

    const requiredFields = this.constructRequiredFields(required_fields);
    return {
      ...requiredFields,
      quantityInput: quantity,
      'order-made-for': order_made_for,
      specialInstructions: special_instructions
    };
  };

  /**
   * Builds the required field objects that is readable by redux form.
   */
  constructRequiredFields = requiredFields => {
    return requiredFields.reduce((acc, current) => {
      const fieldType = getFieldType(current.min_qty, current.max_qty);
      if (fieldType === RADIO_BUTTON) {
        acc[current.slug] = current.selected[0].option_slug;
      } else {
        const checkBoxSelection = current.selected.reduce((field, cur) => {
          field[cur['option_slug']] = true;
          return field;
        }, {});

        acc[current.slug] = checkBoxSelection;
      }
      return acc;
    }, {});
  };

  getProductSlug = () => {
    const cartItemObject = this.getCartItemObject();
    return get(cartItemObject, 'item_slug', null);
  };

  getCartItemObject = () => {
    const { cart, match } = this.props;
    const { cartItemId } = match.params;
    const { items } = cart;
    const cartItemObject = find(items, { id: parseInt(cartItemId) });
    return cartItemObject;
  };

  closeModal = () => {
    const { location, dispatch } = this.props;
    const path = get(location, 'state.path', '/menu');
    dispatch(closeEditCartForm(path));
  };

  render() {
    const { menuItemImage, cartItemPreviewHelper, orderMaximum } = this.props;
    const {
      description,
      name,
      variants,
      spicy,
      vegetarian,
      vegan,
      kosher,
      halal,
      organic,
      dairy,
      peanut,
      tree_nut,
      dairy_free,
      peanut_free,
      tree_nut_free,
      egg,
      shellfish,
      wheat,
      egg_free,
      shellfish_free,
      gluten_free,
      fish,
      soy,
      fish_free,
      soy_free,
      calories,
      id,
      slug
    } = this.props.menuItem;

    const { match } = this.props;

    return (
      <React.Fragment>
        {this.getProductSlug() && (
          <LaunchNotificationOnMount handleCallback={this.closeModal} />
        )}
        <ModalCloseButton
          autoFocus
          handleClick={this.closeModal}
          isWhite={!!menuItemImage}
        />
        {menuItemImage && (
          <MenuItemImage src={menuItemImage} onClose={this.closeModal} />
        )}
        <MenuItemDescription
          name={name}
          spicy={spicy}
          vegetarian={vegetarian}
          vegan={vegan}
          kosher={kosher}
          halal={halal}
          organic={organic}
          dairy={dairy}
          peanut={peanut}
          tree_nut={tree_nut}
          dairy_free={dairy_free}
          peanut_free={peanut_free}
          tree_nut_free={tree_nut_free}
          egg={egg}
          shellfish={shellfish}
          wheat={wheat}
          egg_free={egg_free}
          shellfish_free={shellfish_free}
          gluten_free={gluten_free}
          fish={fish}
          soy={soy}
          fish_free={fish_free}
          soy_free={soy_free}
          calories={calories}
          description={description}
        />
        <Box pl={2.5} pr={2.5} pb={2.5}>
          <MenuItemDetailForm
            variants={variants}
            defaultCtaName={UPDATE_ITEM}
            preSelectedFields={this.getPreSelectedFields()}
            handleFormItemSubmit={handleFormItemUpdate}
            cartItemId={match.params.cartItemId}
            productId={id}
            productName={name}
            productSlug={slug}
            orderMaximum={orderMaximum}
            {...cartItemPreviewHelper}
            formType={CART_ITEM}
          />
        </Box>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { cartItemId } = ownProps.match.params;

  const cartItem =
    getCartItemByIdSelector(state.cart, parseInt(cartItemId)) || {};
  const menuItem = getItemByIdSelector(state.menuItemsDetail, cartItem.product);
  const orderMaximum = get(state.cart, 'max_order_amount', 0);

  return {
    menuItem,
    cartItemPreviewHelper: productPreviewHelperSelectorCartItem(state),
    menuItemImage: getMenuItemImage(menuItem),
    cart: state.cart,
    form: state.form,
    orderMaximum
  };
};

export default withRouter(
  connect(mapStateToProps)(withLoading(EditCartItem, MENU_ITEMS_DETAIL))
);
